import styled from 'styled-components';

export const ReceivesSkeletonLoading = styled.div`
  background-color: white;
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  justify-content: center;
  margin: 8px 0;
  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

export const MobileReceiver = styled.div`
  display: none;
  width: ${( {width} ) => width};
  
  @media screen and (min-device-width: 320px) and (max-device-width: 1000px) {
    display: contents;
  }
`;

export const CardReceiver = styled.div`
  display: ${( {open} ) => open ? 'none' : 'block'};
  width: ${( {width} ) => width};
  box-shadow: 0px 4px 4px 0px #00000040;
  margin: 10px 0;
  border: 1px solid #010311;
  border-radius: 6px;

  @media only screen and (max-width: 1000px) {
    display: flex;
    /* padding: 8px 8px; */
    flex-direction: column;

    :nth-child(even) {
       background-color: #DADDF3;
    }
    
    div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .nfAndData {
      border-bottom: 1px solid #9296AC;

      p {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: #010311;

        span {
          padding-left: 4px;
          font-size: 12px;
          font-weight: 400;
          color: #454A67
        }
      }
    }

    .nameSpace {
      border-bottom: 1px solid #9296AC;
      padding: 0 8px;

      p {
        font-size: 16px;
        color: #010311;
        margin: 0;
      }
    }

    .statusValue {
      padding: 8px;

      p {
        margin: 0;
        font-size: 16px;
        color: #46004D;
        font-weight: 700;

      }

    }

    .statusBox {
      background-color: #FFFFFF;
      box-shadow: 0px 4px 4px 0px #00000040;
      border-radius: 12px;
    }

    .nameAndStatus {
      display: flex;
      align-items: flex-end;
      padding: 0 0px;
      font-size: 12px;
      margin-bottom: 2px;

      p {
        margin: 0;
        font-size: 12px;
        font-weight: 700;
        color: #1F2445;
      }

      div {
        font-weight: 400;
        width: 86px;
        height: 20px;
        font-size: 12px;
        padding: 2px 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #DADDF3;
        color: #0B1A8E;
      }
    }

    .description {
      display: flex;
      align-items: flex-end;
      padding: 0 0px;

      div:first-child {
        width: 150px;
        font-size: 12px;
        background-color: #D2F9D6;
        color: #08AA15;
        display: flex;
        justify-content: flex-start;

        p {
          padding-left: 2px;
          margin: 0;
          font-size: 12px;
        }

        p:last-child {
          padding: 2px 2px 2px 2px;
        }
      }
      
      p {
        margin: 0;
        font-size: 12px;
      }
    }
  }
`;